
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'element-ui/lib/alert';
import isEqual from 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import PendoAlert from './pendo-alert.js';
import 'focus-visible/dist/focus-visible.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import Vue from 'vue';
import get from 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import './pendo-tooltip.js';
import './pendo-divider.js';
import 'element-ui/lib/checkbox';
import PendoCheckbox from './pendo-checkbox.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/isPlainObject';
import 'lodash/debounce';
import 'dompurify';
import 'lodash/throttle';
import PendoInput from './pendo-input.js';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import PendoModal from './pendo-modal.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import PendoMultiselect from './pendo-multiselect.js';
import PendoIconButton from './pendo-icon-button.js';
import isEmpty from 'lodash/isEmpty';
import PendoLegalAcknowledgement from './pendo-legal-acknowledgement.js';
import camelCase from 'lodash/camelCase';

var script = {
  name: 'PendoRepeatingTextInput',
  components: {
    PendoInput,
    PendoIconButton,
    PendoButton
  },
  props: {
    value: {
      type: Array,
      default: () => ['']
    },
    validator: {
      type: Function,
      required: true
    },
    theme: {
      type: String,
      default: 'app',
      validator: theme => ['app', 'via'].includes(theme)
    }
  },

  data() {
    return {
      fields: ['']
    };
  },

  computed: {
    disableDelete() {
      return isEqual(this.fields, ['']);
    }

  },
  watch: {
    fields(value) {
      this.$emit('input', value);
    }

  },

  created() {
    this.fields = this.value;
  },

  methods: {
    removeField(i) {
      if (this.fields.length <= 1) {
        this.fields = [''];
      } else {
        this.fields = this.fields.slice(0, i).concat(this.fields.slice(i + 1));
      }
    },

    onInputChange(event) {
      Vue.set(this.fields, event.index, event.value);
    },

    addField() {
      this.fields.push('');
      this.$nextTick(() => {
        this.$refs[`field${this.fields.length - 1}`][0].focus();
      });
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "repeating-text-input"
  }, [_c('div', {
    staticClass: "repeating-text-input__header"
  }, [_vm._t("header")], 2), _vm._v(" "), _vm._t("description"), _vm._v(" "), _vm._l(_vm.fields, function (field, index) {
    return _c('div', {
      key: index,
      staticClass: "repeating-text-input__field-item"
    }, [_c('pendo-input', {
      ref: "field" + index,
      refInFor: true,
      staticClass: "repeating-text-input__field-input",
      attrs: {
        "value": field,
        "autofocus": index === _vm.fields.length - 1,
        "invalid": !_vm.validator(field)
      },
      on: {
        "input": function ($event) {
          return _vm.onInputChange({
            index: index,
            value: $event
          });
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "repeating-text-input__field-input-remove"
    }, [_c('pendo-icon-button', {
      attrs: {
        "tooltip": "Remove",
        "icon": "trash-2",
        "disabled": _vm.disableDelete
      },
      on: {
        "click": function ($event) {
          return _vm.removeField(index);
        }
      }
    })], 1)], 1);
  }), _vm._v(" "), _c('pendo-button', {
    staticClass: "field-input-add",
    attrs: {
      "theme": _vm.theme,
      "type": "link",
      "prefix-icon": "plus",
      "label": "Add Another"
    },
    on: {
      "click": _vm.addField
    }
  })], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = "data-v-2a38d0a7";
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "repeating-text-input.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var RepeatingTextInput = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

var script$1 = {
  name: 'PendoAddUpdateExtensionAppModal',
  components: {
    PendoButton,
    PendoCheckbox,
    PendoModal,
    PendoLegalAcknowledgement,
    PendoMultiselect,
    RepeatingTextInput,
    PendoAlert,
    PendoInput
  },
  props: {
    theme: {
      type: String,
      default: 'p2-light',
      validator: theme => ['app', 'dark', 'p2', 'p2-light', 'p2-dark', 'via'].includes(theme)
    },
    visible: {
      type: Boolean,
      default: false
    },
    createMode: {
      type: Boolean,
      default: false
    },
    regexFlag: {
      type: Boolean,
      default: false
    },
    enableRegex: {
      type: Boolean,
      default: false
    },
    app: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hasV2Permissions: {
      type: Boolean,
      default: true
    },
    isLoadingPlatformExtensionTypes: {
      type: Boolean,
      default: false
    },
    extensionPlatformTypeOptions: {
      type: Array,
      default: () => {
        return [];
      }
    },
    saving: {
      type: Boolean,
      default: false
    },
    submissionError: {
      type: Object,
      default: () => ({})
    },
    isForCustomer: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 775
    }
  },

  data() {
    return {
      appName: '',
      extensionPlatformType: null,
      domainPatterns: this.app.extensionDomainPatterns ? [...this.app.extensionDomainPatterns] : [''],
      regexPatterns: this.app.extensionRegExps ? [...this.app.extensionRegExps] : [''],
      showConfirmOptOut: false,
      showLegalAcknowledgement: false,
      pendingDataConsent: null,
      mutableSubmissionError: null
    };
  },

  watch: {
    submissionError(value) {
      this.mutableSubmissionError = value;
    }

  },
  computed: {
    title() {
      let title = 'Add Extension Application';

      if (!this.createMode) {
        title = this.regexFlag ? 'Edit Regular Expressions' : 'Edit Websites';
      }

      return title;
    },

    showDomainPatterns() {
      return this.createMode || !this.regexFlag;
    },

    showRegularExpressions() {
      return (this.createMode || this.regexFlag) && this.enableRegex;
    },

    isAppNameValid() {
      return this.appName !== '';
    },

    areDomainsValid() {
      return !this.domainPatterns.some(domain => {
        return !this.isValidDomain(domain);
      });
    },

    areRegExpsValid() {
      return !this.regexPatterns.some(regex => {
        return !this.isValidRegex(regex);
      });
    },

    isModalValid() {
      return this.isAppNameValid && this.areDomainsValid && this.areRegExpsValid && !!get(this.extensionPlatformType, 'type');
    },

    consentOptionsNeedingLegalAcknowledgement() {
      return Object.values(get(this.extensionPlatformType, 'consentOptions', {}) || {}).filter(consentOption => consentOption.enabled && !consentOption.legallyAcknowledged);
    },

    showDataCollectionSettings() {
      return Boolean(this.extensionPlatformType && !isEmpty(this.extensionPlatformType.consentOptions) && this.createMode);
    },

    consentOptionsAppPayload() {
      return Object.entries(get(this.extensionPlatformType, 'consentOptions', {})).reduce((appPayload, [consentOptionKey, consentOption]) => {
        if (!consentOption.enabled || !consentOption.legallyAcknowledged) {
          return appPayload;
        }

        if (consentOption.subConsentOptionsType) {
          appPayload[camelCase(consentOption.subConsentOptionsType)] = Object.values(consentOption.subConsentOptions).reduce((validSubConsentOptions, subConsentOption) => {
            if (!subConsentOption.enabled) {
              return validSubConsentOptions;
            }

            validSubConsentOptions.push(subConsentOption.label);
            return validSubConsentOptions;
          }, []);
          return appPayload;
        }

        appPayload.applicationFlags[consentOptionKey] = true;
        return appPayload;
      }, {
        applicationFlags: {}
      });
    }

  },
  methods: {
    emitClose() {
      this.resetModal();
      this.$emit('close', true);
    },

    submitModalCreateApp() {
      if (this.consentOptionsNeedingLegalAcknowledgement.length > 0) {
        this.requestConsent();
        return;
      }

      const app = _objectSpread({
        displayName: this.appName,
        platform: 'extension',
        extensionDomainPatterns: this.domainPatterns,
        extensionRegExps: this.regexPatterns,
        extensionPlatformType: this.extensionPlatformType.type,
        parentAppId: this.extensionPlatformType.parentAppId
      }, this.consentOptionsAppPayload);

      this.$emit('create', app);
    },

    submitModalUpdateDomains() {
      this.$emit('update', this.domainPatterns);
    },

    submitModalUpdateRegex() {
      this.$emit('updateRegex', this.regexPatterns);
    },

    resetError() {
      this.mutableSubmissionError = null;
      this.saving = false;
    },

    resetModal() {
      this.appName = null;
      this.extensionPlatformType = null;
      this.domainPatterns = this.app.extensionDomainPatterns ? [...this.app.extensionDomainPatterns] : [''];
      this.regexPatterns = this.app.extensionRegExps ? [...this.app.extensionRegExps] : [''];
    },

    onNameInputChange(value) {
      this.appName = value;
    },

    isValidDomain(domain) {
      if (domain === '') {
        return true;
      }

      const validDomainRegex = new RegExp('^([a-z0-9]+(-+[a-z0-9]+)*\\.)+[a-z]{2,}$', 'gm');
      const intranetHostnameRegex = new RegExp('^([a-z0-9]+(-+[a-z0-9]+)*)$');
      return validDomainRegex.test(domain) || intranetHostnameRegex.test(domain);
    },

    isValidRegex() {
      return true;
    },

    toggleConsent(consentOptionKey, value, subConsentOptionKey) {
      this.pendingDataConsent = {
        consentOptionKey,
        subConsentOptionKey
      };

      if (value === false) {
        this.showConfirmOptOut = true;
        return;
      }

      this.cancelOptOut();
    },

    toggleSubConsentOptions(consentOption) {
      const currentOption = get(this.extensionPlatformType.consentOptions[consentOption], 'showSubConsentOptions', false);
      Vue.set(this.extensionPlatformType.consentOptions[consentOption], 'showSubConsentOptions', !currentOption);
    },

    changeConsentOption(enabled) {
      const _this$pendingDataCons = this.pendingDataConsent,
            consentOptionKey = _this$pendingDataCons.consentOptionKey,
            subConsentOptionKey = _this$pendingDataCons.subConsentOptionKey;

      if (subConsentOptionKey) {
        Vue.set(this.extensionPlatformType.consentOptions[consentOptionKey].subConsentOptions[subConsentOptionKey], 'enabled', enabled);
        const someSubConsentOptionsAreEnabled = Object.values(this.extensionPlatformType.consentOptions[consentOptionKey].subConsentOptions).some(subConsentOption => subConsentOption.enabled);
        Vue.set(this.extensionPlatformType.consentOptions[consentOptionKey], 'enabled', someSubConsentOptionsAreEnabled);
        return;
      }

      Vue.set(this.extensionPlatformType.consentOptions[consentOptionKey], 'enabled', enabled);

      for (const subConsentOptionKey in this.extensionPlatformType.consentOptions[consentOptionKey].subConsentOptions) {
        Vue.set(this.extensionPlatformType.consentOptions[consentOptionKey].subConsentOptions[subConsentOptionKey], 'enabled', enabled);
      }
    },

    confirmOptOut() {
      this.changeConsentOption(false);
      this.resetOptOut();
    },

    cancelOptOut() {
      this.changeConsentOption(true);
      this.resetOptOut();
    },

    resetOptOut() {
      this.pendingDataConsent = null;
      this.showConfirmOptOut = false;
    },

    requestConsent() {
      this.showLegalAcknowledgement = true;
    },

    confirmConsent() {
      for (const consentOptionKey in this.extensionPlatformType.consentOptions) {
        Vue.set(this.extensionPlatformType.consentOptions[consentOptionKey], 'legallyAcknowledged', true);
      }

      this.showLegalAcknowledgement = false;
      this.submitModalCreateApp();
    },

    cancelConsent() {
      this.showLegalAcknowledgement = false;
    }

  }
};

const __vue_script__$1 = script$1;

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-modal', {
    staticClass: "pendo-add-update-extension-app-modal",
    attrs: {
      "title": _vm.title,
      "height": "auto",
      "visible": _vm.visible,
      "width": _vm.width,
      "size": "medium"
    },
    on: {
      "close": _vm.emitClose
    }
  }, [_c('template', {
    slot: "body"
  }, [_vm.createMode && _vm.hasV2Permissions ? _c('pendo-alert', {
    staticClass: "pendo-add-update-extension-app-modal__app-permission-alert",
    attrs: {
      "type": "info"
    }
  }, [_vm._v("\n            In order to establish permissions for new apps, this page will refresh and users will be automatically\n            logged out.\n        ")]) : _vm._e(), _vm._v(" "), _vm.mutableSubmissionError ? _c('pendo-alert', {
    staticClass: "pendo-add-update-extension-app-modal__submission-error-alert",
    attrs: {
      "type": "error",
      "closable": true,
      "title": _vm.mutableSubmissionError.errorMessage
    },
    on: {
      "close": _vm.resetError
    }
  }, [_vm._l(_vm.mutableSubmissionError.duplicatePatternErrors, function (error, index) {
    return _c('div', {
      key: index,
      staticClass: "pendo-add-update-extension-app-modal__submission-error-duplicate-item"
    }, [_vm._v("\n                " + _vm._s(error) + "\n            ")]);
  }), _vm._v(" "), _vm._l(_vm.mutableSubmissionError.invalidPatternErrors, function (error, index) {
    return _c('div', {
      key: index,
      staticClass: "pendo-add-update-extension-app-modal__submission-error-invalid-item"
    }, [_vm._v("\n                " + _vm._s(error) + "\n            ")]);
  }), _vm._v(" "), _vm._l(_vm.mutableSubmissionError.duplicateRegExErrors, function (error, index) {
    return _c('div', {
      key: index,
      staticClass: "pendo-add-update-extension-app-modal__submission-error-duplicate-item"
    }, [_vm._v("\n                " + _vm._s(error) + "\n            ")]);
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pendo-add-update-extension-app-modal__app-create-fields"
  }, [_vm.createMode ? _c('div', {
    staticClass: "pendo-add-update-extension-app-modal__app-name-input"
  }, [_c('pendo-input', {
    attrs: {
      "labels": {
        top: 'App Name'
      },
      "autofocus": "",
      "value": _vm.appName
    },
    on: {
      "input": _vm.onNameInputChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.createMode ? _c('div', {
    staticClass: "pendo-add-update-extension-app-modal__app-platform-type"
  }, [_c('pendo-multiselect', {
    attrs: {
      "loading": _vm.isLoadingPlatformExtensionTypes,
      "value-key": "type",
      "full-width": "",
      "labels": {
        top: 'Extension Platform Type'
      },
      "append-to-body": false,
      "allow-empty": false,
      "options": _vm.extensionPlatformTypeOptions
    },
    scopedSlots: _vm._u([{
      key: "noData",
      fn: function () {
        return [_vm._v("\n                        All available extension platform types configured\n                    ")];
      },
      proxy: true
    }], null, false, 2407278581),
    model: {
      value: _vm.extensionPlatformType,
      callback: function ($$v) {
        _vm.extensionPlatformType = $$v;
      },
      expression: "extensionPlatformType"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm.showDomainPatterns ? [_c('repeating-text-input', {
    staticClass: "repeating-text-input-domain-patterns",
    attrs: {
      "theme": _vm.theme,
      "validator": _vm.isValidDomain
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("\n                    Websites\n                ")];
      },
      proxy: true
    }, {
      key: "description",
      fn: function () {
        return [_c('p', [_vm._v("Add websites you'd like to collect data and deploy guides on.")])];
      },
      proxy: true
    }], null, false, 2789447502),
    model: {
      value: _vm.domainPatterns,
      callback: function ($$v) {
        _vm.domainPatterns = $$v;
      },
      expression: "domainPatterns"
    }
  })] : _vm._e(), _vm._v(" "), _vm.showRegularExpressions ? [_c('repeating-text-input', {
    staticClass: "repeating-text-input-regular-expressions",
    attrs: {
      "theme": _vm.theme,
      "validator": _vm.isValidRegex
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm._v("\n                    Regular Expressions\n                ")];
      },
      proxy: true
    }, {
      key: "description",
      fn: function () {
        return [_c('p', [_vm._v("Be careful. If the regular expression isn't accurate, you will collect more information than is requested by the customer.")]), _vm._v(" "), _c('p', [_vm._v("If you have questions, please reach out to someone in "), _c('b', [_vm._v("#adopt-eng-engagement")]), _vm._v(" for support.")])];
      },
      proxy: true
    }], null, false, 3912724773),
    model: {
      value: _vm.regexPatterns,
      callback: function ($$v) {
        _vm.regexPatterns = $$v;
      },
      expression: "regexPatterns"
    }
  })] : _vm._e(), _vm._v(" "), _vm.showDataCollectionSettings ? [_c('div', {
    staticClass: "pendo-app-data-collection-settings"
  }, [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Data Collection Settings")]), _vm._v(" "), _c('p', [_vm._v("By collecting more data, these settings enable stronger tags to be shared by Pendo to your application and enable stronger custom tags.")]), _vm._v(" "), _c('div', {
    staticClass: "pendo-app-data-collection-settings__consent-options"
  }, _vm._l(_vm.extensionPlatformType.consentOptions, function (consentOption, consentOptionKey) {
    return _c('div', {
      key: consentOptionKey,
      staticClass: "pendo-app-data-collection-settings__consent-option"
    }, [_c('div', [consentOption.subConsentOptions ? _c('span', [_c('pendo-button', {
      attrs: {
        "theme": _vm.theme,
        "size": "mini",
        "type": "tertiary",
        "icon": consentOption.showSubConsentOptions ? 'chevron-down' : 'chevron-right',
        "icon-size": "16"
      },
      on: {
        "click": function ($event) {
          return _vm.toggleSubConsentOptions(consentOptionKey);
        }
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', [_vm.pendingDataConsent !== consentOptionKey ? _c('pendo-checkbox', {
      attrs: {
        "label": consentOption.label,
        "value": consentOption.enabled
      },
      on: {
        "change": function ($event) {
          return _vm.toggleConsent(consentOptionKey, $event);
        }
      }
    }) : _vm._e(), _vm._v(" "), consentOption.showSubConsentOptions ? _c('div', {
      staticClass: "pendo-app-data-collection-settings__sub-consent-options"
    }, _vm._l(consentOption.subConsentOptions, function (subConsentOption, subConsentOptionKey) {
      return _c('pendo-checkbox', {
        key: subConsentOptionKey,
        attrs: {
          "label": subConsentOption.label
        },
        on: {
          "change": function ($event) {
            return _vm.toggleConsent(consentOptionKey, $event, subConsentOptionKey);
          }
        },
        model: {
          value: subConsentOption.enabled,
          callback: function ($$v) {
            _vm.$set(subConsentOption, "enabled", $$v);
          },
          expression: "subConsentOption.enabled"
        }
      });
    }), 1) : _vm._e()], 1)]);
  }), 0), _vm._v(" "), [_c('pendo-modal', {
    attrs: {
      "visible": _vm.showConfirmOptOut,
      "confirm-button-config": {
        type: 'danger',
        label: 'Turn Off'
      },
      "append-to-body": "",
      "type": "confirmation",
      "title": "Warning"
    },
    on: {
      "close": _vm.cancelOptOut,
      "cancel": _vm.cancelOptOut,
      "confirm": _vm.confirmOptOut
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_vm._v("\n                            By turning off this setting, you are opting out of receiving some strong features from Pendo. Tags in your application may be weak and can impact behavior when using Pendo, such as in guides, workflows, paths, etc. "), _c('strong', [_vm._v(" We encourage you to keep this setting on to enable the best Pendo experience.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                            For questions, please reach out directly to your Pendo support representative or "), _c('a', {
          attrs: {
            "href": "mailto:support@pendo.io"
          }
        }, [_vm._v("\n                                contact support.\n                            ")])];
      },
      proxy: true
    }], null, false, 3924249777)
  })], _vm._v(" "), [_c('pendo-legal-acknowledgement', {
    attrs: {
      "visible": _vm.showLegalAcknowledgement,
      "is-for-customer": _vm.isForCustomer,
      "title": "Increased Data Collection",
      "action-button-label": "I Accept"
    },
    on: {
      "confirm-action": _vm.confirmConsent,
      "close": _vm.cancelConsent
    }
  }, [_vm._v("\n                        By enabling:\n                        "), _c('ul', _vm._l(_vm.consentOptionsNeedingLegalAcknowledgement, function (consentOptionNeedingLegalAcknowledgement) {
    return _c('li', {
      key: consentOptionNeedingLegalAcknowledgement.label
    }, [_vm._v("\n                                " + _vm._s(consentOptionNeedingLegalAcknowledgement.label) + "\n                            ")]);
  }), 0), _vm._v("\n                        I understand that Pendo will collect more data on my application. This setting enables Pendo to share feature tags which use that data to generate a strong tag rule.\n                        "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                        To change these settings in the future, please reach out directly to your Pendo support representative or "), _c('a', {
    attrs: {
      "href": "mailto:support@pendo.io"
    }
  }, [_vm._v("\n                            contact support.\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]], 2)] : _vm._e()], 2), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('pendo-button', {
    attrs: {
      "theme": _vm.theme,
      "type": "secondary",
      "label": "Cancel"
    },
    on: {
      "click": _vm.emitClose
    }
  }), _vm._v(" "), _vm.createMode ? _c('pendo-button', {
    attrs: {
      "theme": _vm.theme,
      "label": "Save",
      "loading": _vm.saving,
      "disabled": !_vm.isModalValid
    },
    on: {
      "click": _vm.submitModalCreateApp
    }
  }) : _vm._e(), _vm._v(" "), !_vm.createMode && _vm.showDomainPatterns ? _c('pendo-button', {
    attrs: {
      "theme": _vm.theme,
      "label": "Save",
      "loading": _vm.saving,
      "disabled": !_vm.areDomainsValid
    },
    on: {
      "click": _vm.submitModalUpdateDomains
    }
  }) : _vm._e(), _vm._v(" "), !_vm.createMode && _vm.showRegularExpressions ? _c('pendo-button', {
    attrs: {
      "theme": _vm.theme,
      "label": "Save",
      "loading": _vm.saving,
      "disabled": !_vm.areRegExpsValid
    },
    on: {
      "click": _vm.submitModalUpdateRegex
    }
  }) : _vm._e()], 1)], 2);
};

var __vue_staticRenderFns__$1 = [];
const __vue_inject_styles__$1 = undefined;
const __vue_scope_id__$1 = undefined;
const __vue_is_functional_template__$1 = false;

function __vue_normalize__$1(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-add-update-extension-app-modal.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoAddUpdateExtensionAppModal = __vue_normalize__$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1);

export default pendoAddUpdateExtensionAppModal;
